module.exports = __webpack_public_path__ + "static/media/about1.05f7ddf4.webp";